export default __webpack_public_path__ + "static/media/1066.1fb53c25.png";